module.exports = __webpack_public_path__ + "static/media/salana_icon.99de30e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salana_icon.png
// module id = 780
// module chunks = 0